import React from "react";
import { Form, Message, Popup, Icon, Header } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";

const timePicker = {
  disableMobile: true,
  enableTime: true,
  noCalendar: true,
  allowInput: true,
  dateFormat: "h:i K"
};

function WebSales(props) {
  const { values, valid, webConfigEnabled, ecommerceEnabled, shopifyConfigEnabled, shopifyStoreFronts } = props;

  // Define validation rules
  const rules = {};
  if (ecommerceEnabled > 0) {
    if (+values.webenabled < 1 && +values.shopify_enabled < 1) {
      rules['ecommercePlatform'] = "required";
    } else {
      delete rules['ecommercePlatform'];
    }
    if (+values.shopify_enabled > 0 && values.shopify_storefront === '') {
      rules['shopify_storefront'] = "required";
    } else {
      delete rules['shopify_storefront'];
    }
  }
  const customMessages = {
    "required.shopify_storefront": "You enabled shopify for this event, please select a storefront from the list.",
    "required.ecommercePlatform": "A platform must be selected."
  }
  props.setRules(rules, customMessages);

  // List shopify storefronts
  let storeFronts = [];
  shopifyStoreFronts && shopifyStoreFronts.forEach(store => {
    storeFronts.push({
      text: store.replace(/\/$/, ""),
      value: store.replace(/\/$/, "")
    });
    return storeFronts;
  });
  let eventEcommerceToggle;
  if (values.id > 0) {
    eventEcommerceToggle = (+values.webenabled > 0 || +values.shopify_enabled > 0) ? 1 : 0;
  } else {
    eventEcommerceToggle = ecommerceEnabled > -1 ? ecommerceEnabled : (webConfigEnabled || shopifyConfigEnabled) ? 1 : 0;
  }
  const eventShopifyToggle = +values.shopify_enabled > -1 ? +values.shopify_enabled : shopifyConfigEnabled ? 1 : 0;

  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Radio
        toggle
        size="large"
        label={
          eventEcommerceToggle > 0 ?
            <label><span><Icon name="shop" color="green" fitted /></span> E-Commerce Enabled</label> :
            <label><span><Icon name="shop" color="red" fitted /></span> E-Commerce Disabled</label>
        }
        value={eventEcommerceToggle}
        name="ecommerceEnabled"
        className="radioToggleBtn"
        checked={eventEcommerceToggle > 0 ? true : false} // Set to default checked if tenant level websales/shopify config(s) enabled
        onChange={props.handleChange}
        disabled={values.id > 0}
      />
      {eventEcommerceToggle > 0 && <Header as='h3'>Choose a platform:</Header>}
      {eventEcommerceToggle > 0 && <Form.Radio
        size="large"
        label="Bump E-Commerce"
        value="bump-ecommerce"
        name="ecommercePlatform"
        checked={+values.webenabled > 0} // Set to checked when Bump-Ecommerce enabled
        onChange={props.handleChange}
        disabled={values.id > 0}
      />}
      {eventEcommerceToggle > 0 && <Form.Radio
        size="large"
        label="Bump Shopify"
        value="bump-shopify"
        name="ecommercePlatform"
        checked={eventShopifyToggle > 0 ? true : false} // Set to checked when Bump-Shopify enabled
        onChange={props.handleChange}
        disabled={!shopifyConfigEnabled || values.id > 0} // Disabled mid-event or if tenant shopify config is turned off
      />}
      {eventShopifyToggle > 0 && <Form.Select
        label="Choose a Shopify storefront"
        name="event.shopify_storefront"
        value={values.shopify_storefront}
        options={storeFronts}
        onChange={props.handleChange}
        disabled={!shopifyConfigEnabled || values.id > 0} // Disabled mid-event or if tenant shopify config is turned off
      />}
      {eventShopifyToggle < 1 && <Form.Field>
        <label>
          <Popup
            trigger={
              <span>
                <Icon name="help circle" color="blue" fitted /> Countdown Title
              </span>
            }
            content="This text will appear above the Proceeds Box and overrides the Countdown Timer Text setting"
            inverted
            wide
          />
        </label>
        <Form.TextArea
          name="event.content_box_right"
          value={values.content_box_right || ""}
          onChange={props.handleChange}>
        </Form.TextArea>
      </Form.Field>}
      {eventShopifyToggle < 1 && <Form.Field error={valid.errors.has("event_start_time")}>
        <label>
          <Popup
            trigger={
              <span>
                <Icon name="help circle" color="blue" fitted /> Countdown End
                Time
              </span>
            }
            content="This setting controls the countdown timer on your E-Commerce homepage. It's recommended to set this to a time that you know will take place before the winning ticket is drawn. Otherwise if you end an event earlier than the time set here, the countdown will immediately change to '0'."
            inverted
            wide
          />
        </label>
        <Flatpickr
          name="event.event_start_time"
          value={values.event_start_time || ""}
          options={timePicker}
          onChange={(_, str, b) =>
            props.handleChange(b.element, {
              name: "event.event_start_time",
              value: str
            })
          }
        />
      </Form.Field>}
      <Form.Group inline>
        <Form.Button
          type="button"
          size="large"
          onClick={() => props.handleStep("non-profit")}
        >
          Go Back{" "}
        </Form.Button>
        <Form.Button
          type="button"
          primary
          size="large"
          onClick={() => props.handleStep("pricing")}
        >
          Save And Continue{" "}
        </Form.Button>
      </Form.Group>
    </Form>
  );
}

export default WebSales;
